<template>
  <div class="page deal">
    Deal
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
